var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoverIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#FF6000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 20.4166H23.1608L20.9554 22.622C20.9156 22.6604 20.8839 22.7064 20.862 22.7573C20.8402 22.8081 20.8287 22.8628 20.8282 22.9181C20.8278 22.9734 20.8383 23.0283 20.8592 23.0795C20.8802 23.1307 20.9111 23.1772 20.9503 23.2163C20.9894 23.2555 21.0359 23.2864 21.0871 23.3074C21.1383 23.3283 21.1932 23.3388 21.2485 23.3384C21.3038 23.3379 21.3585 23.3264 21.4093 23.3046C21.4602 23.2827 21.5062 23.251 21.5446 23.2112L24.4613 20.2945C24.5394 20.2164 24.5833 20.1104 24.5833 19.9999C24.5833 19.8894 24.5394 19.7835 24.4613 19.7053L21.5446 16.7887C21.466 16.7128 21.3608 16.6708 21.2515 16.6717C21.1423 16.6727 21.0378 16.7165 20.9605 16.7938C20.8832 16.871 20.8394 16.9755 20.8385 17.0848C20.8375 17.194 20.8795 17.2993 20.9554 17.3778L23.1608 19.5833H15.8333C15.7228 19.5833 15.6169 19.6272 15.5387 19.7053C15.4606 19.7834 15.4167 19.8894 15.4167 19.9999C15.4167 20.1104 15.4606 20.2164 15.5387 20.2946C15.6169 20.3727 15.7228 20.4166 15.8333 20.4166Z",
    fill: "#FF6000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverIcon);
export default __webpack_public_path__ + "static/media/hoverIcon.1d154ec09563745de572135d8a069da4.svg";
export { ForwardRef as ReactComponent };